'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Support overscroll-behavior props syntax.
// https://caniuse.com/#search=overscroll-behavior
exports['default'] = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;
    if (_prefix2['default'].js === 'ms') {
      return _prefix2['default'].css + 'scroll-chaining';
    }
    return prop;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/overscroll-behavior.js
// module id = 18
// module chunks = 0